module.exports = __webpack_public_path__ + "c943e6efb8de4d5a3d76884d60137b8d.pdf";